import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HXProgressBar2Container, HXProgressBar2InnerContainer, HXProgressBar2Text, HXProgressBarContainer, HXProgressBarInner, } from "./HXProgressBar.styles";
import { colors } from "healthex-common/colors";
export const HXProgressBar = (props) => {
    const { height, progress, rounded, backgroundColor, innerBackgroundColor } = props;
    return (_jsx(HXProgressBarContainer, { height: height, backgroundColor: backgroundColor, children: _jsx(HXProgressBarInner, { progress: progress, rounded: rounded, backgroundColor: innerBackgroundColor }) }));
};
export const HXProgressBar2 = (props) => {
    const { progress } = props;
    return (_jsxs(HXProgressBar2Container, { children: [_jsx(HXProgressBar2InnerContainer, { children: _jsx(HXProgressBar, { height: 4, progress: progress, backgroundColor: colors.sunset_30, innerBackgroundColor: colors.sunset_main, rounded: false }) }), _jsxs(HXProgressBar2Text, { children: [progress.toFixed(0), "%"] })] }));
};
